/* eslint-disable global-require,no-underscore-dangle */
import { createStore as _createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { responsiveStoreEnhancer } from 'redux-responsive';
import thunk from 'redux-thunk';
import createMiddleware from './middleware/clientMiddleware';
import promiseMiddleware from './middleware/promiseMiddleware';
import facebookMiddleware from './middleware/facebookMiddleware';
import googleMiddleware from './middleware/googleMiddleware';
import { actionListenersStoreEnhancer } from './components/Decorators/withAnalytics';
import reducer from './stores/reducer';
import config from '../config/config';

export default function createStore(history, client, data) {
  // Sync dispatched route actions to the history
  const middleware = [
    promiseMiddleware,
    facebookMiddleware,
    googleMiddleware,
    createMiddleware(client),
    routerMiddleware(history),
    thunk
  ];

  let finalCreateStore;
  if (
    (config.isStaging || config.isDevelopment) &&
    __CLIENT__ &&
    !config.isTesting
  ) {
    // eslint-disable-next-line import/no-extraneous-dependencies
    const { persistState } = require('redux-devtools');

    const composeEnhancers =
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    finalCreateStore = composeEnhancers(
      responsiveStoreEnhancer,
      applyMiddleware(...middleware),
      persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)),
      actionListenersStoreEnhancer
    )(_createStore);
  } else {
    finalCreateStore = compose(
      responsiveStoreEnhancer,
      applyMiddleware(...middleware),
      actionListenersStoreEnhancer
    )(_createStore);
  }

  const store = finalCreateStore(reducer, data);

  if (__DEVELOPMENT__ && module.hot) {
    module.hot.accept('./stores/reducer', () => {
      store.replaceReducer(require('./stores/reducer'));
    });
  }

  return store;
}
